// 대운 전환 장면 문장(승인됨). 원본은 이 파일 하나다. 검사: node ai/scripts/check-links.mjs
// 화면: '{나이}세 · {영역} 쪽 새 대운이 들어와요. {문장}' — 대운이 시작한 해부터 3년 동안 대운 패널에 보이고, 시작한 해에 진행 기록에 한 줄 남는다.
export const LUCK_SCENES = {
  "status": "approved-by-user",
  "note": "대운 전환 장면 문장 15개(승인됨). 사용자가 2026-10-19에 문장을 그대로 승인했다. 승인된 전환 유형 표의 칸(순용·역용 × 관계 6종)과 같은 구조이며, 격국×십성 예외로 유형이 달라진 칸은 유형별 일반 문장(byType)을 쓴다. 고서 원문 확인 전이라 needsCheck 를 유지한다. 이 파일이 유일한 원본이고 ai/scripts/check-links.mjs 가 검사한다.",
  "relations": {
    "순용": {
      "같은십성": "지금까지 해 온 방식이 힘을 얻는 시기예요. 하던 일을 이어 가면 성과가 쌓여요.",
      "같은그룹다른십성": "비슷한 기운이 섞여 들어와 방향을 다시 정리해야 해요. 맡은 일의 우선순위를 가려 보세요.",
      "대운이격국을생": "새 기운이 지금 쓰는 힘을 받쳐 줘요. 도움이 되는 사람과 자료가 늘어나요.",
      "대운이격국을극": "새 기운이 지금 방식과 부딪쳐요. 무리하면 일이 어긋나기 쉬우니 속도를 조절해야 해요.",
      "격국이대운을생": "가진 힘을 쓸 곳이 생겨요. 쌓아 둔 것을 내보이기 좋은 시기예요.",
      "격국이대운을극": "새 기운을 내가 눌러야 하는 시기예요. 맡는 역할이 바뀔 수 있어요."
    },
    "역용": {
      "같은십성": "거친 기운이 한 번 더 강해져요. 충돌이 커지기 쉬우니 끝을 정하고 움직여야 해요.",
      "같은그룹다른십성": "비슷한 기운이 섞여 들어와 방향을 다시 정리해야 해요. 하나로 모을지 나눌지 정해 보세요.",
      "대운이격국을생": "새 기운이 지금의 거친 면을 키워요. 의욕이 앞서 일을 키우지 않도록 조심해야 해요.",
      "대운이격국을극": "새 기운이 거친 면을 눌러 줘요. 방식을 다듬고 정리하기 좋은 시기예요.",
      "격국이대운을생": "가진 힘이 쓸 곳을 찾아요. 재능을 결과로 바꿀 기회가 열려요.",
      "격국이대운을극": "내 방식이 새 기운과 정면으로 부딪쳐요. 양보할 부분과 지킬 부분을 가려야 해요."
    }
  },
  "byType": {
    "돕는": "지금의 방식이 힘을 얻는 시기예요.",
    "막는": "하던 방식이 부딪치기 쉬운 시기예요.",
    "바꾸는": "방향을 다시 정해야 하는 시기예요."
  },
  "cardIds": [
    "JP-순용역용",
    "DC-luck"
  ],
  "needsCheck": true,
  "approvedOn": "2026-10-19"
};
